<template>

  <div class="workshops-regular" :class="{'scrolled' : windowPageYOffset>0}">

    <nav-1></nav-1>

    <!-- <div class="content-text bg-light">
      <h2 class="">
        Learn with Hato
      </h2>
    </div> -->
    <!-- Learn through play and take your pick of these creative workshops – curated by us. -->

    <!-- <hero-video></hero-video> -->

    <!-- <img class="content-image" src="../assets/workshops/pop.png"> -->


    <!-- <div class="carousel-wrapper bg-light">
      <flickity class="carousel" ref="flickity" :options="flickityOptions">
        <div class="carousel-cell">
          <div class="carousel-media">
            <hero-video :size="'65%'" :fill="'cover'"></hero-video>
          </div>
          <div class="carousel-text">
          </div>
        </div>
        <div class="carousel-cell" v-for="(cell, index) in carousel" :key="index">
          <div class="carousel-media" :style="{'backgroundImage': 'url(' + cell.image + ')', 'backgroundPosition': index === 2 ? 'top center' : 'bottom center'}" ></div>
          <div class="carousel-text" >
            <p v-html="cell.title"></p>
            <a v-if="cell.url" :href="cell.url + getQuery()">Details &rarr;</a>
          </div>
        </div>
      </flickity>
    </div> -->

    <carousel></carousel>

    <timetable></timetable>

    <!-- <christmas></christmas> -->

    <instagrams></instagrams>

    <gift></gift>

    <div class="action content-text">
      <h2 class="">
        Get in touch to learn more about our bespoke workshops, or any general enquiries on workshops.
      </h2>
      <a class="button" href="mailto:learn@hatopress.net">learn@hatopress.net</a>
      <a class="button" href="tel:+44-207-729-5585">+44 (0)207 729 5585</a>
    </div>


  </div>

</template>

<script>

// import CaseStudiesData from '@/store/CaseStudiesData'
// import '../assets/styles/animate.css'
// import Waypoints from 'waypoints'
// import Vue from 'vue'

import Nav1 from '@/components/Nav1'
import HeroVideo from '@/components/HeroVideo'
import Flickity from '@/components/Flickity'
import Timetable from '@/components/Timetable'
import Carousel from '@/components/Carousel'
import Instagrams from '@/components/Instagrams'
import Christmas from '@/components/Christmas'
import Gift from '@/components/Gift'
// import _ from 'lodash'

export default {
  ready: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  beforeDestroy: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  components: {
    Nav1,
    HeroVideo,
    Flickity,
    Timetable,
    Instagrams,
    Gift,
    Christmas,
    Carousel
  },
  // created () {
  //   this.fetchData()
  // },
  data () {
    return {
      scrollEventAdded: false,
      windowPageYOffset: 0,
      carousel: null,
      flickityOptions: {
        // contain: true,
        initialIndex: 0,
        // prevNextButtons: false,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        // ,
        autoPlay: 3000
      }
    }
  },
  computed: {
    windowSize () {
      return window.innerWidth
    }
  },
  mounted () {
    // this.initWaypoints()
    // this.fetchData()
  },
  methods: {
    // fetchData () {
    //   if (process.env.NODE_ENV === 'production') {
    //     this.error = this.carousel = null
    //     this.$http.get('./static/timetable.json').then(response => {
    //       return response.json()
    //     }).then(json => {
    //       // error callback
    //       this.getSummaryFromWorkshops(json.highlights)
    //     }, response => {
    //       // error callback
    //       console.log('error')
    //     })
    //   } else {
    //     let tt = require('../assets/data/timetable.json')
    //     this.getSummaryFromWorkshops(tt.highlights)
    //   }
    // },
    // getSummaryFromWorkshops (highlights) {
    //   // this.carousel = _.uniqBy(workshops, 'title')
    //   this.carousel = highlights
    //   // this.$refs.flickity.reloadCells()
    //   // let self = this
    //   // self.$refs.flickity.initFlickity()
    //   // setTimeout(function () {
    //   //   self.$refs.flickity.initFlickity()
    //   //   // self.$refs.flickity.reloadCells()
    //   //   let flkty = self.$refs.flickity.flickity
    //   //   if (flkty) {
    //   //     flkty.on('staticClick', self.flkty_staticClick)
    //   //   }
    //   // }, 100)
    // },
    addScrollEvent () {
      if (this.scrollEventAdded) return
      this.scrollEventAdded = true
      window.addEventListener('scroll', (e) => {
        // console.log(e)
        console.log()
        this.windowPageYOffset = window.pageYOffset
      })
    },
    handleResize: function (event) {
      console.log('handleResize:', event)
    },
    // imagePath: function (source) {
    //   if (source.indexOf('http') >= 0) {
    //     return source
    //   } else {
    //     let ss = source
    //     let mysource = require('../assets/projects/' + ss + '.jpg')
    //     return mysource
    //   }
    // },
    isMobile: function () {
      let self = this
      return self.windowSize < 640
    },
    // flkty_staticClick: function (event, pointer, cellElement, cellIndex) {
    //   let self = this
    //   let flkty = self.$refs.flickity.flickity
    //   if (cellIndex === flkty.selectedIndex) {
    //     if (self.carousel[cellIndex] && self.carousel[cellIndex].url) {
    //       // disable carousel click
    //       // window.location.href = self.carousel[cellIndex].url
    //     } else {
    //       return
    //     }
    //   } else
    //   if (cellIndex >= flkty.selectedIndex) {
    //     // console.log('next')
    //     self.$refs.flickity.next()
    //   } else {
    //     // console.log('prev')
    //     self.$refs.flickity.previous()
    //   }
    // },
    getQuery: function () {
      let self = this
      let query = '?'

      query += '_=_'
      // query += self.$route.query && self.$route.query.length > 0 ? '?' : ''
      query += self.$route.query.utm_campaign ? '&utm_campaign=' + self.$route.query.utm_campaign : ''
      query += self.$route.query.utm_content ? '&utm_content=' + self.$route.query.utm_content + '-carouselaction' : '&utm_content=carouselaction'
      query += self.$route.query.utm_medium ? '&utm_medium=' + self.$route.query.utm_medium : ''
      query += self.$route.query.utm_source ? '&utm_source=' + self.$route.query.utm_source : ''
      query += self.$route.query.utm_term ? '&utm_term=' + self.$route.query.utm_term : ''
      query += self.$route.query.mc_cid ? '&mc_cid=' + self.$route.query.mc_cid : ''
      query += self.$route.query.mc_eid ? '&mc_eid=' + self.$route.query.mc_eid : ''

      return query
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-image {
  margin: auto;
  margin: 2rem auto;
  max-width: 500px;
}

.content-text {
  margin: auto;
  padding: 0 1rem;
  margin: 4rem auto 2rem;
  text-align: center;
  max-width: 900px;
}


h2 {
  margin-top: 0;
  text-align: center;
  max-width: 700px;
}

.carousel-wrapper {
  /* margin: 1.5rem 0 2rem; */
  padding: 1rem 0 1rem;
  width: 100%;
  /*height: 500px;*/
  position: relative;
  background: #fafafa;
}

.carousel {
  /*position: absolute;*/
  top:0;
  left: 0;
  width: 100%;
  /*height: 100%;*/
}

.carousel-cell {
  /* width: 700px;
  height: 550px; */
  width: 900px;
  height: 550px;
  margin: 0 .5rem;
}

.carousel-media {
  /*width: 700px;*/
  /*height: 500px;*/
  width: 100%;
  height: 0;
  padding-bottom: 61%;
  margin: 0 auto;
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  /*pointer-events: none;*/
  cursor: pointer;
  position: relative;
}
.carousel-text {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 1rem;

  z-index: 99;
  margin: 1rem auto 0;
  text-align: left;
  cursor: pointer;
  max-width: 24em;
  /*pointer-events: none;*/
}
.carousel-text p,
.carousel-text a {
  display: block;
  margin-top: .25rem;
  margin-bottom: 0;
}
.carousel-text p {
  font-weight: 500;
}
.carousel-text a {
  /* color: hsl(159, 89%, 50%) */
  /* color: hsl(159, 89%, 50%) */
}


.flickity-enabled.is-draggable .flickity-viewport {
  cursor: pointer;
}

.workshop-listing {
  max-width: 1000px;
  margin: 1rem auto;
  padding: 2rem 2rem 2rem;
  border-bottom: 1px solid rgba(0,0,0,0.1);
  display: flex;
  justify-content: space-between;
}
.workshop-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: #fafafa;
}
.workshop-info {
  margin-left: 2rem;
  margin-right: auto;
  color: #666;
}
.workshop-info h3 {
  max-width: 400px;
  font-weight: 500;
  margin-top: 0;
  color: #000;
}
.workshop-action a {
  display: block;
  font-size: .8em;
  padding: .6em 1.5em;
  border: 1px solid;
}



.action {
  padding: 2rem 0;
  margin: 2rem auto 4rem;
  max-width: 800px;
}
/*
a.button {
  display: inline-block;
  margin: 0 1rem;
  padding: .5em 1em;
  border: 1px solid #000
}*/

.action a {
  display: inline-block;
  /*font-size: .8em;*/
  margin: 0 1em;
  padding: .6em 1.5em;
  /*border: 1px solid;*/
  border-radius: 8px;
  border-radius: 5px;
  background: hsl(159, 89%, 93%);
  background: hsl(159, 89%, 80%);
}
.action a:hover {
  background: hsl(159, 89%, 70%);
}



@media screen and (max-width: 1024px) {
  .carousel-cell {
    width: 90vw;
    height: auto;
  }
  .carousel-media {
    /*width: 600px;
    height: 400px;*/
  }
  .content-text {
    /* position: relative;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0; */
    margin: 2rem auto 2rem;
  }
  .carousel-text {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    margin-top: 0;
    margin-left: 0;
    padding-left: 0;
  }
  .carousel-text p,
  .carousel-text a {
    font-size: 1rem;
  }
}
@media screen and (max-width: 768px) {
  /* .carousel-cell {
    width: 600px;
    height: 500px;
    margin: 0 50px;
  } */
  .carousel-media {
    /*width: 600px;
    height: 400px;*/
  }
  .content-image {
    max-width: 400px;
  }
  .carousel-text {
    /* margin: 1rem auto 0; */
  }
}
@media screen and (max-width: 640px) {
  /* .carousel-cell {
    width: 80%;
    height: 75vw;;
    margin: 0 10px;
  } */
  .carousel-media {
    /*width: 300px;
    height: 200px;*/
  }
  .content-image {
    max-width: 80%;
  }
  .action {
    padding: 1rem;
    margin: 1rem auto 2rem;
  }
  .action a {
    /*display: block;*/
    margin: .5em 1em;
  }
}
</style>



// WEBPACK FOOTER //
// WorkshopsRegular.vue?139941ec